


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DropdownLinks } from 'types/header';
import { Link } from 'types/layout';

@Component
export default class NavigationLinkSubmenu extends Vue {
	@Prop({ required: true })
	link!: DropdownLinks;

	get hasActiveSubMenuItem(): boolean {
		return !!this.link.links.find((link: Link) => link.router === this.$route?.name);
	}

	get baseLinkButtonClasses() {
		const base = 'main-nav__menu-item-link main-nav__menu-item-link--has-dropdown-arrow';

		return this.hasActiveSubMenuItem ? base + ' router-link-active' : base;
	}
}
